export default __webpack_public_path__ + "static/media/DeLaCruz.8536aa57.jpg";